import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "data/backOfficeConnector";
import type EventBus from "services/eventBus";
import type { IPagination } from "data/types";
import type OutgoingPayGatePaymentsRequest from "entities/outgoingPayGatePaymentsRequest";
import { serializeFilters } from "utils/filters";
import OutgoingPayGatePaymentResponse from "entities/outgoingPayGatePaymentResponse";
import OutgoingPayGatePaymentDetailResponse from "entities/outgoingPayGatePaymentDetailResponse";

export default class OutgoingPayGateRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAllOutgoingPayGatePayments(pagination: IPagination, filters: OutgoingPayGatePaymentsRequest, abortSignal: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("outgoing_paygate_payments")
          .postPagedEntities<OutgoingPayGatePaymentResponse>(
            serializeFilters(filters, false),
            OutgoingPayGatePaymentResponse,
            abortSignal,
            pagination
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  getAllOutgoingPayGatePaymentsExport(filters: OutgoingPayGatePaymentsRequest) {
    return this.callApi(
      api => api.all("finance").all("outgoing_paygate_payments").all("report").postOnly(serializeFilters(filters, false)),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }

  async getOutgoingPayGatePayment(itemId: string) {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("outgoing_paygate_payments")
          .one(itemId)
          .getEntity<OutgoingPayGatePaymentDetailResponse>(OutgoingPayGatePaymentDetailResponse),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "1.1" }),
      }
    );
  }
}
